import { useSelector } from "react-redux";
import { useForm, FormProvider } from "react-hook-form";
import Compensation from "./_sections/personal-details/Compensation";
import { Stack } from "@mui/material";
import Personality from "./_sections/personal-details/Personality";
import Contact from "./_sections/personal-details/Contact";
import LookingFor from "./_sections/personal-details/LookingFor";
import PersonalInformation from "./_sections/personal-details/PersonalInformation";
import { CatButton } from "assets/styled-components/CatButton";
import GeneralUtilityService from "services/GeneralUtilityService";
import { useEffect, useMemo } from "react";

export default function PersonalDetailsForm({ onSubmit }) {
    const personalDetails = useSelector(
        (state) => state.currentCandidateAI.personalDetails,
    );
    const {
        compensation,
        personality,
        contact,
        lookingFor,
        personalInformation,
    } = personalDetails || {};

    const defaultValues = useMemo(
        () => ({
            compensation: {
                currencyId: compensation?.currencyId?.data ?? null,
                compensations: compensation?.compensations?.data ?? [],
                netMonthlySalary: compensation?.netMonthlySalary?.data ?? null,
                grossAnnualSalary:
                    compensation?.grossAnnualSalary?.data ?? null,
                availability:
                    GeneralUtilityService.convertDateToMonthInput(
                        compensation?.availability?.data,
                    ) ?? "",
                noticePeriod: compensation?.noticePeriod?.data ?? null,
            },
            personality: {
                attitude: personality.attitude?.data || null,
                motivations: personality.motivations?.data || [],
                softSkills: personality.softSkills?.data || [],
            },
            contact: {
                contactFrequency: contact.contactFrequency?.data || null,
                meansOfContact: contact.meansOfContact?.data || [],
            },
            lookingFor: {
                jobFunctions: lookingFor.jobFunctions?.data || [],
                occupations: lookingFor.occupations?.data || [],
                hardSkills: lookingFor.hardSkills?.data || [],
                companySizes: lookingFor.companySizes?.data || [],
                relocation: lookingFor.relocation?.data || null,
                industries: lookingFor.industries?.data || [],
                jobTypes: lookingFor.jobTypes?.data || [],
                workingModels: lookingFor.workingModels?.data || [],
            },
            personalInformation: {
                vehicles: personalInformation.vehicles?.data || [],
                gender: personalInformation.gender?.data || null,
                languages: personalInformation.languages?.data || [],
            },
        }),
        [compensation, personality, contact, lookingFor, personalInformation],
    );

    const methods = useForm({ defaultValues });
    useEffect(() => {
        methods.reset(defaultValues);
    }, [personalDetails, methods, defaultValues]);

    if (!compensation) {
        return <div>Loading...</div>;
    }

    return (
        <FormProvider {...methods}>
            <Stack onSubmit={methods.handleSubmit(onSubmit)} component="form">
                <Compensation data={compensation} />
                <Personality data={personality} />
                <Contact data={contact} />
                <LookingFor data={lookingFor} />
                <PersonalInformation data={personalInformation} />
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        mt: 2,
                        position: "sticky",
                        bottom: "0",
                        right: "0",
                        zIndex: 10,
                        justifyContent: "flex-end",
                        backgroundColor: "white",
                        margin: "0 -24px",
                        padding: "8px 16px",
                        boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
                        alignContent: "center",
                    }}
                >
                    <CatButton
                        size="medium"
                        variant="contained"
                        type="submit"
                        sx={{ width: "fit-content" }}
                    >
                        Submit Candidate Information
                    </CatButton>
                </Stack>
            </Stack>
        </FormProvider>
    );
}
